// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__1hwJA","footer__content":"footer_footer__content__Qu5Kr","footer__desc":"footer_footer__desc__2Oh7q","footer__copyright":"footer_footer__copyright__p2xe1"};